// extracted by mini-css-extract-plugin
export default {"title":"Counterparties_title__4JVf0","button":"Counterparties_button__Qs37S","headerContainer":"Counterparties_headerContainer__RnmME","icon":"Counterparties_icon__QzQaH"};